import { SUPPORTED_LOCALES } from 'locales/constants';

const normalizeSegments = (value = '') => value.split('/').filter(Boolean);

export const buildLocalizedPath = (locale, baseName, pathParts, search = '') => {
    const segments = [locale, ...normalizeSegments(baseName), ...pathParts].filter(Boolean);
    return `/${segments.join('/')}${search}`;
};

/**
 * Builds an application route while preserving the active locale and basename.
 */
export const buildAppPath = (
    targetPath,
    pathname = window.location.pathname,
    baseName = process.env.REACT_APP_BASE_NAME || ''
) => {
    const currentParts = normalizeSegments(pathname);
    const locale = SUPPORTED_LOCALES.includes(currentParts[0]) ? currentParts[0] : '';
    return buildLocalizedPath(locale, baseName, normalizeSegments(targetPath));
};
